import { AbstractProjectModel } from "@app/catalog-common";


export class SelectProjectMessage {
  selected: AbstractProjectModel;

  constructor(selected: AbstractProjectModel) {
    if (selected != undefined) {
      this.selected = selected;
    }
  }
}